import {Component} from '@angular/core';
import {AuthControllerService, MerchantControllerService, UserControllerService} from '../../@services/gen';
import {AuthService} from '../../@services/auth.service';
import {Router} from '@angular/router';
import {LocalstorageService} from '../../@services/localstorage.service';
import {NotificationService} from '../../@services/notification.service';
import {UserShiftService} from "../../@services/user-shift.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  username: string;
  password: string;
  loading: boolean;
  errMsg: string;
  showPassword = false;
  currentYear = new Date().getFullYear();

  constructor(
    private authService: AuthControllerService,
    private customAuthService: AuthService,
    private router: Router,
    private userService: UserControllerService,
    private merchantService: MerchantControllerService,
    private ls: LocalstorageService,
    private ns: NotificationService,
    private userShiftService: UserShiftService
  ) {}

  login(): void {
    let dialogRef = this.ns.showNotification({
      message: 'Logging in...',
      manualClose: true,
      icon: 'fa fa-sync',
    });

    this.errMsg = '';

    this.loading = true;
    this.authService
      .loginPost({
        username: this.username,
        password: this.password,
      })
      .subscribe(
        async (res) => {
          this.customAuthService.saveUser(res['user']);
          const merchant = await this.loadMerchant();
          if (!merchant) {
            dialogRef.close();
            this.loading = false;
            return;
          }

          let userShift = await this.loadUserShift();
          if (!userShift) {
            this.router.navigate(['/shift-opening']);
          } else {

            this.userShiftService.saveUserShift(userShift);
            this.router.navigate(['/']);
          }
          dialogRef.close();

          this.loading = false;

        },
        (res) => {
          dialogRef.close();
          this.loading = false;


          // Check if error is due to disabled/suspended/terminated merchant
          if (res?.error?.message) {
            const errorMessage = res.error.message;

            // Check if message starts with "Account" (our custom format)
            if (errorMessage.startsWith('Account ')) {
              // Extract the status (e.g., "SUSPENDED" from "Account SUSPENDED")
              const accountStatus = errorMessage.replace('Account ', '');

              // Show blocking modal with the actual status
              this.ns.showAccountSuspendedDialog(accountStatus);
              this.errMsg = ''; // Clear inline error message
              return;
            }
          }

          // Default error handling for other login failures
          this.errMsg = res?.error?.message ?? 'Invalid username or password';
        }
      );
  }

  async loadUserShift() {
    const merchant = this.ls.getMerchant();
    if (!merchant || !merchant.id) {
      return null;
    }

    return await this.userService
      .getUserShiftPost({
        merchantId: merchant.id,
        cashierId: this.customAuthService.getUser().userId
      })
      .toPromise();
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  async loadMerchant() {
    const user = this.customAuthService.getUser();
    const merchantId = user && user.merchants && user.merchants.length > 0 ? user.merchants[0].id : null;
    if (!merchantId) {
      this.errMsg = 'No merchant assigned to this user';
      return null;
    }

    let merchant = await this.merchantService
      .getMerchantPost({
        id: merchantId,
      })
      .toPromise();
    if (!merchant) {
      this.errMsg = 'Failed to load merchant profile';
      return null;
    }

    this.ls.saveMerchant(merchant);
    return merchant;
  }
}
